import axios from './config';

const list = (params, successCb, errorCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/indexed-searches`, { params },
  ).then(
    res => successCb(res.data),
  ).catch(
    err => errorCb(err),
  );
};

const get = (id, successCb) => {
  axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/indexed-search/${id}`,
  ).then(
    res => successCb(res.data),
  ).catch(
    err => console.error('api.indexedSearch.get() received error from api request:', err),
  );
};

const post = (params, successCb, errorCb) => {
  if (params.indexedSearch.active === '1') {
    params.indexedSearch.active = true;
  }
  if (params.indexedSearch.active === '0') {
    params.indexedSearch.active = false;
  }

  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/indexed-search`,
    params.indexedSearch,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const put = (params, successCb, errorCb) => {
  if (params.indexedSearch.active === '1') {
    params.indexedSearch.active = true;
  }
  if (params.indexedSearch.active === '0') {
    params.indexedSearch.active = false;
  }

  let { indexedSearch } = params;

  axios.put(
    `${process.env.REACT_APP_API_BASE_URL}/indexed-search/${params.id}`,
    indexedSearch,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const importTexts = (params, successCb, errorCb) => {
  let texts = params;

  axios.post(
    `${process.env.REACT_APP_API_BASE_URL}/indexed-search/import-texts`,
    texts,
  ).then(
    res => successCb(res.data),
  ).catch(
    errorCb,
  );
};

const endpoints = {
  list,
  get,
  post,
  put,
  importTexts,
};

export default endpoints;